import clsx from 'clsx';
import {navigate} from 'gatsby';
import {NavArrowRightIcon} from '../icons';
import * as styles from './card.module.css';

interface ICardProps {
    disabled?: boolean,
    hideArrow?: boolean,
    linkTo?: string,
    onClick?: () => void,
    title: string,
    isActive?: boolean,
    hasWarning?: boolean,
    hasError?: boolean,
}

const Card = ({
    disabled = false,
    hideArrow = false,
    isActive,
    linkTo,
    onClick,
    title,
    hasWarning = false,
    hasError = false,

}: ICardProps) => {
    const handleOnClick = () => {
        if (disabled) {
            return;
        }

        if (onClick) {
            onClick();

            return;
        }

        if (linkTo) {
            navigate(linkTo);
        }
    };

    return (
        <div
            className={clsx(
                styles.root,
                isActive && styles.active,
                hideArrow && styles.noArrow,
                disabled && styles.disabled,
                (linkTo || onClick) && styles.cursor,
                hasWarning && styles.warning,
                hasError && styles.error,
            )}
            onClick={() => {
                if (hideArrow) {
                    handleOnClick();
                }
            }}
        >
            <div className={styles.title}>
                <span >
                    {title}
                </span>
            </div>
            {!hideArrow && (
                <div
                    className={styles.link}
                    onClick={handleOnClick}
                >
                    <NavArrowRightIcon/>
                </div>
            )}
        </div>
    );
};

export default Card;
